import React, { ReactNode } from "react";
import { usePageStyles } from "../styles/usePageStyles";
import { Grid } from "antd";

type CardVariant = 'indigo' | 'pink' | 'emerald' | 'purple';

interface GlassCardProps {
  title?: string;
  icon?: ReactNode;
  children: ReactNode;
  variant?: CardVariant;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Reusable glassmorphism card component
 */
export const GlassCard: React.FC<GlassCardProps> = ({
  title,
  icon,
  children,
  variant = 'indigo',
  className,
  style
}) => {
  const styles = usePageStyles();
  const breakpoint = Grid.useBreakpoint();
  const isMobile = typeof breakpoint.lg === 'undefined' ? false : !breakpoint.lg;
  return (
    <div 
      style={{ ...styles.card, ...(isMobile ? styles.cardMobile : {}), ...style }} 
      className={className}
    >
      {(title || icon) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          {icon && (
            <div style={styles.cardIcon(variant)}>
              {icon}
            </div>
          )}
          {title && (
            <h3 style={styles.cardTitle}>{title}</h3>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
